export const FIELD_ASSOC_RESET_HEADER = "Confirm Field Association Reset";
export const FIELD_ASSOC_RESET_BODY =
	"This Data Layer has fields associated with it. Performing this action will delete associations and you will need to go through the rest of the wizard again. Do you want to continue?";
